export const registerTextStyle = 'my-[30px] font-semibold text-[#888]';
